<template>
  <Container
    @drop="drop"
    class="layer-container"
    :group-name="groupName"
    :drop-placeholder="dropPlaceholder"
    :get-child-payload="getChildPayload"
    :should-accept-drop="shouldAcceptDrop"
  >
    <Draggable
      :key="layer.id"
      v-for="layer in layers"
    >
      <Layer :layer="layer"/>
    </Draggable>
  </Container>
</template>
<script>
import { Container, Draggable } from 'vue-smooth-dnd'
import Layer from '../layer'
export default {
  name: 'ICLayerContainer',
  components: {
    Container,
    Draggable,
    Layer
  },
  inject: [
    'layers',
    'addLayer',
    'swapLayer',
    'removeLayer'
  ],
  props: {
    pid: {
      type: [Number, String],
      default: () => undefined
    },
    groupName: {
      type: String,
      default: () => 'container'
    }
  },
  data () {
    return {
      dropPlaceholder: {
        className: 'drop-placeholder'
      }
    }
  },
  methods: {
    getChildPayload (index) {
      return this.layers[index]
    },
    shouldAcceptDrop () {
      // sourceContainerOptions, payload
      // console.log('shouldAcceptDrop:', this.groupName)
      // console.log('shouldAcceptDrop:', sourceContainerOptions)
      // console.log('shouldAcceptDrop payload:', payload)
      return true
    },
    drop (dropResult) {
      const { addedIndex, removedIndex, payload } = dropResult
      const isAdd = addedIndex !== null
      const isRemove = removedIndex !== null
      if (addedIndex !== removedIndex) {
        if (isAdd && isRemove) {
          // TODO 交换组件位置
          this.swapLayer(
            this.layers[addedIndex],
            this.layers[removedIndex]
          )
        } else if (isAdd) {
          // TODO 拖入组件
          this.addLayer({
            ...payload,
            pid: this.pid
          })
        } else if (isRemove) {
          // TODO 拖出组件
          this.removeLayer(this.layers[removedIndex])
        }
      }
    }
  }
}
</script>
